/**
 * Portalın derneği.
 *
 * Üretimde alt alan adından gelir: `butad.akillidernek.com`. Geliştirmede
 * alt alan adı yok; sırayla `?dernek=` sorgusu (tarayıcıda saklanır),
 * `VITE_PORTAL_TENANT` ve saklanmış seçim denenir. Portal kullanıcısı
 * dernek SEÇMEZ — hangi derneğin portalına geldiyse odur; bu yüzden panelin
 * "dernek değiştir" akışı burada yok.
 */
const STORAGE_KEY = 'akillidernek.portal.tenant'

function altAlanAdi(): string | null {
  const kok = import.meta.env.VITE_ROOT_DOMAIN
  if (!kok) return null
  const host = window.location.hostname.toLowerCase()
  const ek = `.${kok.toLowerCase()}`
  if (!host.endsWith(ek)) return null
  const alt = host.slice(0, -ek.length)
  return alt && !alt.includes('.') ? alt : null
}

function coz(): string | null {
  const sorgu = new URLSearchParams(window.location.search).get('dernek')
  if (sorgu) {
    try {
      localStorage.setItem(STORAGE_KEY, sorgu)
    } catch {
      // Depolama yoksa yalnızca bu sekmede yaşar.
    }
    return sorgu
  }
  const alt = altAlanAdi()
  if (alt) return alt
  if (import.meta.env.VITE_PORTAL_TENANT) return import.meta.env.VITE_PORTAL_TENANT
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export const tenantSlug: string | null = coz()

export function getTenantSlug(): string | null {
  return tenantSlug
}
